'use strict';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _require = require('fpx'),
    isFunction = _require.isFunction,
    validate = _require.validate;

var _require2 = require('./lifetime'),
    isDeinitable = _require2.isDeinitable;

/**
 * Interfaces
 */

// Happens to be a subset of `isObservable`. Potential confusion. How to fix?


exports.isSubscription = isSubscription;
function isSubscription(value) {
  return isDeinitable(value) && isFunction(value.trigger);
}

/**
 * Classes
 */

var Subscription = function () {
  function Subscription(observable, callback) {
    _classCallCheck(this, Subscription);

    validate(isObservable, observable);
    validate(isFunction, callback);
    this.observable = observable;
    this.callback = callback;
    this.state = this.states.ACTIVE;
  }

  Subscription.prototype.trigger = function trigger() {
    if (this.state === this.states.ACTIVE) {
      this.callback.apply(this, arguments);
    }
  };

  Subscription.prototype.deinit = function deinit() {
    if (this.state === this.states.ACTIVE) {
      this.state = this.states.IDLE;
      this.observable.unsubscribe(this);
    }
  };

  return Subscription;
}();

exports.Subscription = Subscription;

Subscription.prototype.states = {
  ACTIVE: 'ACTIVE',
  IDLE: 'IDLE'
};

// Duplicated to avoid circular dependency
function isObservable(value) {
  return Boolean(value) && isFunction(value.subscribe) && isFunction(value.unsubscribe);
}


//////////////////
// WEBPACK FOOTER
// ./~/espo/dist/subscription.js
// module id = 378
// module chunks = 118